import ButtonComp from "themes/elements/Button";

function ModalFooter(props) {
  const {
    handlePrimaryBtn,
    handleSecondaryBtn,
    hidePrimaryBtn = false,
    hideSecondaryBtn = false,
    primaryBtnText = "",
    primaryBtnVariant = "primary",
    secondaryBtnText = "",
    secondaryBtnLoading = false,
    primaryBtnprefix = null,
    primaryBtnloading = false,
    secondaryBtnprefix = null,
    secondaryBtnvariant = "primary",
    extraBtn = null,
  } = props;
  return (
    <>
      {!hidePrimaryBtn && (
        <ButtonComp
          onClick={handlePrimaryBtn}
          variant={primaryBtnVariant}
          loading={primaryBtnloading}
          prefix={primaryBtnprefix}
        >
          {primaryBtnText}
        </ButtonComp>
      )}
      {!hideSecondaryBtn && (
        <ButtonComp
          onClick={handleSecondaryBtn}
          loading={secondaryBtnLoading}
          prefix={secondaryBtnprefix}
          variant={secondaryBtnvariant}
        >
          {secondaryBtnText}
        </ButtonComp>
      )}
      {extraBtn}
    </>
  );
}

export default ModalFooter;
